import React, { useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Layout from "./components/Layout";
import HomePage from "./pages/Home";
import KnowledgeBasePage from "./pages/KnowledgeBase";
import { AuthProvider } from "./context/AuthContext";
import SecureRoute from "./components/SecureRoute";
import { msalInstance } from "./services/authService";

function App() {
  // Handle redirect response at app root
  useEffect(() => {
    const handleRedirect = async () => {
      try {
        console.log("Checking for authentication redirect response...");
        await msalInstance.handleRedirectPromise();

        // If we have accounts after redirect, we're successfully logged in
        if (msalInstance.getAllAccounts().length > 0) {
          msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
          console.log("Authentication successful, user account found");
        }
      } catch (err) {
        console.error("Error processing authentication redirect:", err);
      }
    };

    handleRedirect();
  }, []);

  return (
    <AuthProvider>
      <Routes>
        {/* Protected routes */}
        <Route
          path="/"
          element={
            <SecureRoute>
              <Layout>
                <HomePage />
              </Layout>
            </SecureRoute>
          }
        />
        <Route
          path="/knowledge-base"
          element={
            <SecureRoute>
              <Layout>
                <KnowledgeBasePage />
              </Layout>
            </SecureRoute>
          }
        />

        {/* Catch-all: redirect unknown routes to home */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthProvider>
  );
}

export default App;
